import React from 'react';
import { Box } from 'src/components/Box';

import { useSidebarDialog } from './SidebarDialogContext';
import { SidebarDialogSidebarProps } from './SidebarDialogTypes';

export const SidebarDialogSidebar: React.FC<SidebarDialogSidebarProps> = ({
  children,
  open,
  width = '288px',
}) => {
  const { isMobile, sidebarOpen } = useSidebarDialog();

  // Use prop value if provided, otherwise fall back to context
  const isOpen = open !== undefined ? open : sidebarOpen;

  // Don't render sidebar on mobile or when closed
  if (isMobile || !isOpen) {
    return null;
  }

  return (
    <Box
      sx={{
        minWidth: width,
        borderRight: '1px solid',
        borderColor: 'divider',
        p: 2,
      }}
    >
      {children}
    </Box>
  );
};
